import { render, staticRenderFns } from "./bfpageword.vue?vue&type=template&id=10b20fbe&scoped=true&"
import script from "./bfpageword.vue?vue&type=script&lang=js&"
export * from "./bfpageword.vue?vue&type=script&lang=js&"
import style0 from "./bfpageword.vue?vue&type=style&index=0&id=10b20fbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b20fbe",
  null
  
)

export default component.exports